import { AISummary } from "~types/types";

import { RenderCardType } from "..";
import { PersonalizationStory } from "../PersonalizationStory";

export const getCards = ({
    aiSummary,
    personalizedStories,
    personalizedVideoStories,
}: {
    aiSummary: AISummary;
    personalizedStories?: PersonalizationStory[];
    personalizedVideoStories?: PersonalizationStory[];
}) => {
    const cards = [];

    cards.push({
        type: RenderCardType.AI_SUMMARY,
        aiSummaryText: aiSummary.text,
    });

    if (Array.isArray(personalizedStories) && personalizedStories.length > 0) {
        cards.push({
            type: RenderCardType.PERSONALIZATION,
            stories: personalizedStories,
        });
    }

    if (
        Array.isArray(personalizedVideoStories) &&
        personalizedVideoStories.length > 0
    ) {
        cards.push({
            type: RenderCardType.VIDEO,
            videos: personalizedVideoStories,
        });
    }

    return cards;
};
